/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {FC, useEffect, useState, useMemo, useCallback, useRef} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  getLaundryWashingTime,
  getLaundryWashingTimeReportPDF,
  getLaundryWashingTimeReportXLS,
  getLaundryWashingTimeReportCSV,
} from '../../../../services'
import {FormProvider, useForm} from 'react-hook-form'
import {Select} from '../../../../../../components/UI/Select'
import InputDate from '../../../../../../components/UI/Input/inputDate'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaLaundryWashingTimeFilter} from '../../../../../../util/validationLavanderia'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {
  LaundryWashingTimeModel,
  LaundryWashingTimeSearchModel,
} from '../../../../features/laundryFrecuency/model/laundryWashingTime.model'
import {donwloadFile} from '../../../../helpers/utilities'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {getFormatDate} from '../../../../../../util/functions'
import {useCamp, useClient, useSite, useCompany} from '../../../../../central/hooks'
import {SelectModel} from '../../../../model'

interface FormattedDate {
  fecha: string
  tiempo: string
  fechaMin: string
}

const downloadReportForType = {
  pdf: getLaundryWashingTimeReportPDF,
  xlsx: getLaundryWashingTimeReportXLS,
  csv: getLaundryWashingTimeReportCSV,
}

type TypeDownloadReport = keyof typeof downloadReportForType

const TableLaundryTime: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const [formValue, setFormValue] = useState<any>(null)
  const [searching, setIsSearching] = useState<boolean>(false)
  const [isOpenDownloadMenu, setIsOpenDownloadMenu] = useState<boolean>(false)
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const {isAllowed} = useLavanderia()
  const refWrapperDownload = useRef<HTMLDivElement | null>(null)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const methods = useForm({
    resolver: yupResolver(schemaLaundryWashingTimeFilter),
  })

  const {
    control,
    formState: {errors},
    register,
    setValue,
    getValues,
    handleSubmit,
    setError,
    reset,
  } = methods

  const values = getValues()

  const {
    rooms,
    guests,
    washedOrdenStatus,
    contratist,
    laundryPoint,
    getLaundryPointList,
    getRooms,
    getContratist,
    getWashedOrderStatus,
    handleClearList,
    getGuests,
  } = useLaundryFilter()
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
      getLaundryPointList(response[0].value)
    }
    setCamps(response)
  }
  useEffect(() => {
    getCompanyList()
  }, [])
  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
  }

  const handleFilterLaundryPoint = (e: any) => {
    let value = e.value
    getLaundryPointList(value)
    getGuests(value)
    getRooms(value)
    setValue('campamentoId', value)
    setError('campamentoId', {})
  }

  const getLaundryList = useCallback(
    async (props: LaundryWashingTimeSearchModel = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryWashingTime({...props}, pagination.currentPage)
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
      setIsSearching(false)
    },
    [setLoading, setData, pagination.currentPage],
  )

  const columns: Column<LaundryWashingTimeModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Punto de Lavandería' />,
        accessor: 'puntoLavanderia',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nº Orden Lavandería' />,
        accessor: 'nroOrdenLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo Servicio' />,
        accessor: 'tipoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de registro de orden' />,
        accessor: 'fechaRegistroOrden',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaRegistroOrden
            ? getFormatDate(props.data[props.row.index].fechaRegistroOrden)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='KG Lavados' />,
        accessor: 'kgLavados',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Administración' />,
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Proveedor' />,
        accessor: 'proveedor',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de recepción' />,
        accessor: 'fechaRecepcion',
        Cell: ({...props}) => {
          let dateReception = props.data[props.row.index].fechaRecepcion
            ? getFormatDate(props.data[props.row.index].fechaRecepcion)
            : ''
          return <span>{dateReception ? (dateReception as FormattedDate).fecha : ''}</span>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de entrega Programada' />,
        accessor: 'fechaEntregaProgramada',
        Cell: ({...props}) => {
          let dateProgram = props.data[props.row.index].fechaEntregaProgramada
            ? getFormatDate(props.data[props.row.index].fechaEntregaProgramada)
            : ''
          return <span>{dateProgram ? (dateProgram as FormattedDate).fecha : ''}</span>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de Salida' />,
        accessor: 'fechaSalida',
        Cell: ({...props}) => {
          let dateOut = props.data[props.row.index].fechaSalida
            ? getFormatDate(props.data[props.row.index].fechaSalida)
            : ''
          return <span>{dateOut ? (dateOut as FormattedDate).fecha : ''}</span>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo Responsable' />,
        accessor: 'tipoResponsable',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Responsable Orden' />,
        accessor: 'responsableOrden',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Habitación' />,
        accessor: 'habitacion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Estado de la Orden' />,
        accessor: 'estadoOrden',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nº Boleta Impresa' />,
        accessor: 'nroBoletaImpresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Boleta Impresa' />,
        accessor: 'boletaImpresa',
        Cell: ({...props}) => {
          return <span>{`${props.data[props.row.index].boletaImpresa ? 'Si' : 'No'}`}</span>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Boleta Re Impresa' />,
        accessor: 'boletaReImpresa',
        Cell: ({...props}) => {
          return <span>{`${props.data[props.row.index].boletaReImpresa ? 'Si' : 'No'}`}</span>
        },
      },
    ],
    [],
  )

  const onSubmit = (dataForm: LaundryWashingTimeSearchModel) => {
    setIsSearching(true)
    const {fechaPeriodoFin: fin, fechaPeriodoInicio: inicio} = dataForm
    const data = {
      ...dataForm,
      fechaPeriodoInicio: inicio ? new Date(inicio) : '',
      fechaPeriodoFin: fin ? new Date(fin) : '',
    }
    getLaundryList(data)
    setFormValue(data)
  }

  const handleToggleOpenMenu = () => {
    setIsOpenDownloadMenu(!isOpenDownloadMenu)
  }

  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    setIsDownload(true)
    setIsOpenDownloadMenu(false)
    let data = {}
    if (formValue) {
      data = {
        ...formValue,
      }
    }
    const response = await downloadReportForType[typeFormat](data)
    await donwloadFile(response.data, typeFormat)
    setIsDownload(false)
  }

  const handleResetForm = () => {
    reset()
    handleClearList()
  }

  useEffect(() => {
    getLaundryList()
  }, [pagination.currentPage])

  useEffect(() => {
    getCompanyList()
    getContratist()
    getWashedOrderStatus()
  }, [])

  useEffect(() => {
    handleClearList()
    const values = ['clienteId', 'siteId', 'campamentoId', 'puntoId', 'habitacionId', 'huespedId']
    for (const value of values) {
      setValue(value, '')
    }
  }, [values.companiaId])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (refWrapperDownload.current && !refWrapperDownload.current.contains(event.target)) {
        setIsOpenDownloadMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('BUSCAR_ENCABEZADO') && (
          <div className='p-6'>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Compañía:</label>
                    <Select
                      control={control}
                      name='companiaId'
                      data={company}
                      errors={errors}
                      onChangeValue={handleFilterClient}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Cliente:</label>
                    <Select
                      control={control}
                      disabled={clients.length === 0}
                      name='clienteId'
                      data={clients}
                      errors={errors}
                      onChangeValue={handleFilterSite}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Site:</label>
                    <Select
                      control={control}
                      name='siteId'
                      data={sites}
                      disabled={sites.length === 0}
                      errors={errors}
                      onChangeValue={handleFilterCamp}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Campamento:</label>
                    <Select
                      control={control}
                      name='campamentoId'
                      data={camps}
                      disabled={camps.length === 0}
                      errors={errors}
                      onChangeValue={handleFilterLaundryPoint}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Puntos de Lavandería:</label>
                    <Select
                      control={control}
                      disabled={laundryPoint.length === 0}
                      name='puntoId'
                      data={laundryPoint}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Huésped:</label>
                    <Select
                      control={control}
                      disabled={guests.length === 0}
                      name='huespedId'
                      data={guests}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Habitación:</label>
                    <Select
                      control={control}
                      disabled={rooms.length === 0}
                      name='habitacionId'
                      data={rooms}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Contrata:</label>
                    <Select
                      control={control}
                      disabled={contratist.length === 0}
                      name='contrataId'
                      data={contratist}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Estado Orden Lavado:</label>
                    <Select
                      disabled={washedOrdenStatus.length === 0}
                      control={control}
                      name='estadoOrden'
                      data={washedOrdenStatus}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha Inicio:</label>
                    <InputDate name='fechaPeriodoInicio' register={register} errors={errors} />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha Fin:</label>
                    <InputDate name='fechaPeriodoFin' register={register} errors={errors} />
                  </div>
                </div>
                <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                  <Button label='Buscar' loading={searching} typeBtn='submit' />
                  <Button
                    label='Limpiar'
                    disabled={!values.companiaId}
                    onClick={() => handleResetForm()}
                  />
                  {isAllowed('EXPORTAR') && (
                    <div className='position-relative' ref={refWrapperDownload}>
                      <button
                        className='sdx_btn gap-2'
                        type='button'
                        disabled={isDownload}
                        onClick={handleToggleOpenMenu}
                      >
                        {isDownload ? (
                          <div className='icon-container'>
                            <i className='loader'></i>
                          </div>
                        ) : (
                          <KTSVG
                            path='/media/icons/duotune/files/fil021.svg'
                            className='svg-icon-1'
                          />
                        )}
                        Descargar Reporte
                      </button>
                      <div
                        className='menu bg-white position-absolute end-0 z-index-3 border mt-1 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                        style={{display: isOpenDownloadMenu ? 'block' : 'none'}}
                      >
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('pdf')}
                          >
                            Descargar como PDF
                          </div>
                        </div>
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('xlsx')}
                          >
                            Descargar como XLSX
                          </div>
                        </div>
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('csv')}
                          >
                            Descargar como CSV
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </ButtonWrapper>
              </form>
            </FormProvider>
          </div>
        )}
        {isAllowed('LISTAR') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryTimeWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryTime />
    </KTableProvider>
  )
}

export {TableLaundryTimeWrapper}
